import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.less'],
})
export class ChipComponent {
  @Input() text: String;
  @Input() chips: any[];

}
